"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const directive_1 = require("./directive");
const plugin = (app) => {
    app.directive("mask", directive_1.useMask);
};
exports.default = plugin;
